import { AutoStartVoice } from "@/store/note/types";
import { syntaxTreeModule } from "@mem-labs/common-editor";
import { DateTime } from "luxon";

export const createNoteEncodedContentForAutoStartVoice = (autoStartVoice: AutoStartVoice) => {
  if (!autoStartVoice || typeof autoStartVoice !== "object") return;

  const primaryLabel = `[${
    autoStartVoice.windowTitle || "Meeting"
  }] – ${(autoStartVoice.startTime ? DateTime.fromISO(autoStartVoice.startTime) : DateTime.now()).toFormat("LLLL d, yyyy")}`;
  const secondaryLabel = "";

  const h1 = document.createElement("h1");
  h1.textContent = primaryLabel;
  const p = document.createElement("p");
  p.textContent = secondaryLabel;
  const p2 = document.createElement("p");
  const html = document.createElement("html");
  html.appendChild(h1);
  html.appendChild(p);
  html.appendChild(p2);

  const htmlContent = html.outerHTML;
  const encodedContent = syntaxTreeModule.convertHtmlToEncodedContent({ htmlContent });
  return { encodedContent, primaryLabel, secondaryLabel };
};
